import React from 'react';

type InformationBoxProps = {
  title: string;
  items: string[];
  titleColor?: string;
  className?: string;
};

export const InformationBox: React.FC<InformationBoxProps> = ({
  title,
  items,
  titleColor = 'text-yellow-500',
  className = '',
}) => {
  return (
    <div className={`flex flex-col gap-3 p-4 border bg-[#F4F4F4] rounded-lg ${className}`}>
      <h3
        className={`text-base font-semibold ${titleColor}`}
        style={{
          fontFamily: 'var(--ep-font-avenir)',
        }}
      >
        {title}
      </h3>
      <ul
        className="flex flex-col gap-2 text-sm text-gray-700 list-disc list-inside"
        style={{
          fontFamily: 'var(--ep-font-avenir)',
        }}
      >
        {items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  );
};
